import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton } from 'primereact/skeleton';
import { callApi, showSweetAlert } from 'utils/utils';
import { config } from 'utils/config';
import FieldButton from 'components/Controls/FieldButton/FieldButton';
import {
  buildPreviewSrcDoc,
  buildSignatureData,
  findDefaultPhoneRows,
  resolveFeaturedRow,
  writeSignatureToClipboard,
} from './signatureUtils';
import './MyBusinessCard.css';

// Read-only signature viewer for any business card (admin use): renders the same
// composed signature as the self-service screen, honoring the user's saved featured
// contacts, with a copy button.
const SignatureViewer = ({ ClaUsuarioBC }) => {
  const { t } = useTranslation(['qr', 'common']);

  const [IsLoading, setIsLoading] = useState(true);
  const [Info, setInfo] = useState(null);
  const [ContactInfo, setContactInfo] = useState(null);
  const [Version, setVersion] = useState(Date.now());

  useEffect(() => {
    setIsLoading(true);
    const url = `${config.UrlApiProject}QRCode/GetVCardInfo?ClaUsuario=${ClaUsuarioBC}`;
    callApi(url, 'GET', null, (response) => {
      setInfo(response.data.info);
      setContactInfo(response.data.contactInfo);
      setVersion(Date.now());
      setIsLoading(false);
    }, () => {
      setIsLoading(false);
    });
  }, [ClaUsuarioBC]);

  const signatureData = (version) => {
    const emails = ContactInfo.Email || [];
    const phones = ContactInfo.Phone || [];
    const { mobileRow, officeRow } = findDefaultPhoneRows(phones);

    return buildSignatureData({
      ClaUsuarioBC,
      FullName: Info.FullName,
      JobTitle: Info.JobTitle,
      emailRow: resolveFeaturedRow(Info.FeaturedEmailContactId, emails, emails.length > 0 ? emails[0] : null),
      mobileRow: resolveFeaturedRow(Info.FeaturedMobileContactId, phones, mobileRow),
      officeRow: resolveFeaturedRow(Info.FeaturedOfficeContactId, phones, officeRow),
      version,
    });
  };

  const onCopySignatureClick = async () => {
    if (await writeSignatureToClipboard(signatureData(Date.now()))) {
      showSweetAlert(null, t('qr:SignatureCopied'), 'success');
    } else {
      showSweetAlert(null, t('qr:SignatureCopyFailed'), 'error');
    }
  };

  if (IsLoading) {
    return <Skeleton height="18rem" />;
  }

  if (Info === null) {
    return <div className="text-center text-muted p-4">{t('qr:SignatureLoadFailed')}</div>;
  }

  return (
    <>
      <div className="email-signature-preview-frame">
        <iframe
          title={t('qr:SignaturePreview')}
          srcDoc={buildPreviewSrcDoc(signatureData(Version))}
          className="email-signature-preview-iframe"
          scrolling="no"
        />
      </div>
      <div className="mt-3">
        <FieldButton
          label={t('qr:CopySignature')}
          icon="pi pi-copy"
          className="p-button-success"
          onClick={onCopySignatureClick}
        />
      </div>
    </>
  );
};

export default SignatureViewer;
